import { CompanionCardFooter } from '@/components/companion/cards/CompanionCardShell';
import type { CompanionPresenterProps } from '@/components/companion/feed/presenters/presenter-types';
import { CompanionCardHeader } from '@/components/companion/cards/CompanionCardHeader';
import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/**
 * The card any kind gets before it has a presenter of its own.
 *
 * It shows only what every card carries — its title, its reason and the label
 * of its call to action — because there is nothing kind-specific it could read
 * without knowing the kind. The evidence is not lost: the "Why?"
 * panel renders it for every kind.
 *
 * It keeps a frame of its own rather than the card shell's: this card is only
 * ever rendered inside the panel, which is already the frame, so it draws no
 * background and no border.
 */
export const GenericActionCard = ({
  action,
  onOpenCta,
  onDismiss,
  isCtaPending = false,
  isCtaDisabled = false,
  footerEnd,
}: CompanionPresenterProps) => {
  const { t } = useTranslation();

  return (
    <Stack gap="14px" p="18px" pb="16px" data-testid="companion-generic-card">
      <CompanionCardHeader title={action.title} reason={action.reason} />

      <CompanionCardFooter
        ctaLabel={action.ctaLabel}
        onOpenCta={onOpenCta}
        onDismiss={onDismiss}
        isCtaPending={isCtaPending}
        isCtaDisabled={isCtaDisabled}
        ctaDisabledHint={t('companion.panel.cta.comingSoon')}
        footerEnd={footerEnd}
      />
    </Stack>
  );
};
